import { PreviousUploadResponse } from "./PreviousUploadResponse";

export class CheckForReuploadResponse {
  PreviousUploads: PreviousUploadResponse[];
}
